import React from 'react'
import styles from "./serviceDetailSec.module.css";
import i18n from '../../../i18n';
import { LANG_AR } from '../../helpers/constant';

const ServiceDetailBanner = ({ title, disc, img }) => {
    return (
        <div className={styles.ServiceDetailBanner}>
            <div className={styles.ServiceDetailBannerOutter}>
                <div className={`${styles.ServiceDetailBannerInner} ${i18n.language===LANG_AR ? 'arab':''}`}>
                    <div className={`${styles.ServiceDetailBannerInnerLeft} ${i18n.language===LANG_AR ? 'arabText':''}`}>
                        <h3>{title}</h3>
                        
                        {/* <p dangerouslySetInnerHTML={{ __html: disc }}></p> */}
                        <div dangerouslySetInnerHTML={{ __html: disc }} />

                        
                    </div>
                    <div className={styles.ServiceDetailBannerInnerRight}>
                        <img src={img} alt="" loading='lazy' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceDetailBanner
